module.exports = __webpack_public_path__ + "images/banner4b961fa6ba2e5a5818d1b3f140e222a6.png";